const Routes = [
  {
    path: '/monthly-sales',
    name: 'MonthlySales',
    component: () => import('@/app/monthly_sales/TheMonthlySales'),
    redirect: '/monthly-sales/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/monthly_sales/views/Index')
      }
    ]
  }
]
export default Routes



// WEBPACK FOOTER //
// ./src/app/monthly_sales/Routes.js